import { useEffect } from "react";
import { Link } from "react-router-dom";

export const Header = ({ data }) => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "//chatserver2.webservio.net/js/phplive_v2.js.php?v=4|1660162057|0|&";
    script.async = true;
    const container = document.getElementById("phplive_btn_1660162057");

    if (container) {
      container.appendChild(script);
      const launchChat = () => {
        if (typeof window.phplive_launch_chat_4 === "function") {
          window.phplive_launch_chat_4();
        }
      };
      container.addEventListener("click", launchChat);
      return () => {
        container.removeEventListener("click", launchChat);
      };
    }
  }, []);

  const renderMenu = (items, isSub = false) => (
    <ul className={`${isSub ? "dropdown-menu" : "navbar-nav"}`}>
      {items.map((item, idx) => {
        const hasSubmenu = item.submenu && item.submenu.length > 0;
        return (
          <li
            key={idx}
            className={`nav-item ${hasSubmenu ? "dropdown" : ""} ${isSub ? "dropdown-submenu" : ""}`}
          >
            <Link
              to={item.href}
              className={`nav-link ${hasSubmenu ? "dropdown-toggle" : ""}`}
              {...(hasSubmenu
                ? {
                    role: "button",
                    "data-bs-toggle": isSub ? "dropdown" : "dropdown",
                    "aria-expanded": "false",
                  }
                : {})}
            >
              {item.name}
            </Link>
            {hasSubmenu && renderMenu(item.submenu, true)}
          </li>
        );
      })}
    </ul>
  );

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light main-nav">
      <div className="container">
        <Link className="navbar-brand" to="/">
          <img src="img/logo.png" alt="logo" className="logo" width="250" />
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarNav">
          {renderMenu(data)}
          <div className="header-cta ms-auto">
            <a className="me-3" href="tel:8667904678">
              <i className="fa fa-phone"></i> 866.790.4678
            </a>
            <span id="phplive_btn_1660162057" style={{ cursor: "pointer" }}></span>
          </div>
        </div>
      </div>
    </nav>
  );
};


